<template>
  <div class="result-item" :class="{active: isActive}">
    <span class="name">{{item.name}}</span>
    <span class="email">{{item.email}}</span>
  </div>
</template>
<script>

export default {
  name: 'UsersItem',
  props: {
    item: {},
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .result-item {
    border-bottom: 1px solid #e1e1e1;
    cursor: pointer;
    padding: 5px 0 5px 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &:hover{
      background-color: #dddddd;
    }
  }
  .active{
    background-color: #dddddd;
  }

  .name{
   font-weight: 500;
  }
  .email{
    font-size: 12px;
  }
</style>
